﻿'use strict';

/**
* Directive for the drop down menu
* @memberOf components.uiElements.dropDownMenuModule
* @namespace ebBasicDropDownMenu
*/

ebBasicDropDownMenu.$inject = ['$window'];

function ebBasicDropDownMenu($window) {
    // Usage: <ebBasicDropDownMenu></ebBasicDropDownMenu>

    var directive = {
        restrict: 'E',
        templateUrl: require('./ebBasicDropDownMenu.html'),
        scope: {
            menuItemList: "=",
            menuItemTitle: "=",
            menuItemId: "=",
            displayMenu: "="
        }
    };
    return directive;
}

module.exports = ebBasicDropDownMenu;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/uielements/dropdownmenu/ebBasicDropDownMenuDirective.js
// module id = 60
// module chunks = 0